import axios, { type AxiosResponse } from 'axios'

import { type SanityFrameBuilderType } from '@frame-builder/data/sanity/queries/types'
import { type FrameBuilderState } from './types'

interface FrameBuilderArtworkPayload {
  width: number
  height: number
}

interface FrameBuilderPassepartoutPayload {
  colorId?: string
  width?: number
  height?: number
}

export interface ShopifyCreateFrameBuilderProductPayload {
  frameBuilderType: SanityFrameBuilderType
  imageDataUrl: string
  artwork: FrameBuilderArtworkPayload
  profileId?: string
  textureId?: string
  passepartout: FrameBuilderPassepartoutPayload
  glassId?: string
  spacerSizeId?: string
  spacerColorId?: string
}

export interface ShopifyCreateFrameBuilderProductResponse {
  productId: string
  productTitle: string
  variantId: number
  variantPrice: number
  variantComparePrice?: number
}

/**
 * Sends a request to create a frame builder product.
 */
export const createFrameBuilderProduct = async (
  locale: string,
  frameBuilderType: SanityFrameBuilderType,
  state: FrameBuilderState,
  productImageDataUrl: string,
) => {
  const createProductPayload: ShopifyCreateFrameBuilderProductPayload = {
    frameBuilderType,
    imageDataUrl: productImageDataUrl,
    artwork: {
      width: state.artwork.width,
      height: state.artwork.height,
    },
    textureId: state.texture?._id,
    profileId: state.profile?._id,
    passepartout: {
      colorId: state.passepartout.color?._id,
      width: state.passepartout.width,
      height: state.passepartout.height,
    },
    glassId: state.glass?._id,
    spacerSizeId: state.spacerSize?._id,
    spacerColorId: state.spacerColor?._id,
  }
  const createProductResponse = await axios.post<
    ShopifyCreateFrameBuilderProductResponse,
    AxiosResponse<ShopifyCreateFrameBuilderProductResponse>,
    string
  >(
    '/api/shopify/frame-builder-product-create',
    JSON.stringify(createProductPayload),
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Locale': locale,
      },
    },
  )

  if (createProductResponse.status !== 200) {
    throw new Error(JSON.stringify(createProductResponse.data))
  }

  return createProductResponse.data
}
